// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__ApoRa","label":"Completed_label__1SONt"};